//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Confirm from '../../shared-components/vuetify/dialog/Confirm';

export default {
  name: 'TipoInvestimentoForm',
  data() {
    return {
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource),
      dialog: {
        content: '',
      },
      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
      },
      tipoInvestimento: {},
    };
  },
  watch: {},
  components: {
    Confirm,
  },
  computed: {
    ehEdicao() {
      return this.tipoInvestimento.id;
    },
  },
  methods: {
    cancel() {
      this.limparFormulario();
      this.$emit('FORMULARIO_CANCELAR');
    },
    editar(item) {
      this.tipoInvestimento = item;
    },
    limparFormulario() {
      this.tipoInvestimento = {};
      this.$refs.form.reset();
    },
    openSaveDialog() {
      if (!this.$refs.form.validate()) return;
      this.dialog.content = this.$t('message.salvar');
      this.$refs.confirmDialog.open();
    },
    save() {
      let salvarOuAtualizar;
      let inclusao = true;
      if (this.tipoInvestimento.id) {
        inclusao = false;
        salvarOuAtualizar = this.tipoInvestimentoResources.atualizar(this.tipoInvestimento);
      } else {
        salvarOuAtualizar = this.tipoInvestimentoResources.gravar(this.tipoInvestimento);
      }

      salvarOuAtualizar.then(() => this.limparFormulario())
        .then(() => this.$toast.create(this.$t((inclusao ? 'message.adicionado_confira_tabela' : 'message.atualizado_confira_tabela'))
          , 'snack', 3E3))
        .then(() => {
          this.$emit('FORMULARIO_SALVAR', Object.assign({ }, this.tipoInvestimento));
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
  },
  mounted() {},
};



// WEBPACK FOOTER //
// ./src/spa/tipo-investimento/TipoInvestimentoForm.vue?vue&type=script&lang=js&